/**
 * Tabellen-Hinweis bleibt sichtbar, solange die Tabelle überläuft.
 * Pfeil zeigt nach rechts am Anfang, nach links sobald gescrollt wurde.
 */
function updateTableScrollState(figure) {
	const viewport = figure.querySelector('.wp-block-table__viewport');
	if (!viewport) {
		return;
	}

	const overflow = viewport.scrollWidth - viewport.clientWidth > 2;
	const atStart = viewport.scrollLeft <= 2;
	const atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;

	figure.classList.toggle('is-scrollable-x', overflow);
	figure.classList.toggle('is-at-start', overflow && atStart);
	figure.classList.toggle('is-at-end', overflow && atEnd);
}

function initTableScrollHints() {
	const figures = document.querySelectorAll('.wp-block-table');
	if (!figures.length) {
		return;
	}

	figures.forEach((figure) => {
		const viewport = figure.querySelector('.wp-block-table__viewport');
		if (!viewport) {
			return;
		}

		const update = () => updateTableScrollState(figure);
		update();
		viewport.addEventListener('scroll', update, { passive: true });

		if (typeof ResizeObserver !== 'undefined') {
			const observer = new ResizeObserver(update);
			observer.observe(viewport);
			const table = viewport.querySelector('table');
			if (table) {
				observer.observe(table);
			}
		} else {
			window.addEventListener('resize', update);
		}
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initTableScrollHints);
} else {
	initTableScrollHints();
}
